module.exports = __webpack_public_path__ + "img/medialuna-dulce2.0b11f1b1.jpeg";